var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns box"},[_c('div',{staticClass:"notification page-integrations__notification--is-warning"},[_c('sc-icon',{attrs:{"icon":"search"}}),_vm._v("\n    Nenhum aplicativo encontrado para integração\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c44226","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/empty-app-list/EmptyAppList.vue
// module id = null
// module chunks = 